export * from './Ctx'
export * from './Dev'
export * from './FormattedMessage'
export * from './Sentry'
export * from './withApp'
export * from './withHtmlTag'
export * from './withI18n'
export * from './withPage'
export * from './withPreRedirect'
export * from './withRedux'
export * from './T'

// 支持对多个 HOC 组装
// 定义 hoc 为 <T>(a: T) => T
// 将 hoc1(hoc2(hoc3(Target))) 的写法，变为 composeHoc(hoc1, hoc2, hoc3)(Target)
export function composeHoc(...hoc) {
  return function (target) {
    let result = target
    hoc.reverse().forEach((h) => {
      result = h(result)
    })
    return result
  }
}
